import { render, staticRenderFns } from "./saletarget.vue?vue&type=template&id=656d2ae6&"
import script from "./saletarget.vue?vue&type=script&lang=js&"
export * from "./saletarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
